module.exports = "https://cdn.hellotech.com/client-assets/overlay_4691d1b6f24a66b4487c91ff381b0e62.jpg";